import { useDispatch } from "react-redux";
import { setAllPackageFromApi, updateClientFormField } from "../../features/client/clientSlice";
import { generateRandomNumber } from "../../utils/generateRandomNumber";
import { formatDateFromApi, formatTimeFromApi } from "../../utils/formatDateAndTime";
import { ExtraPackagesData, Person } from "../../types/client";
import { ClientInfoData } from "../../features/client/clientResponse";
import { SelectPackageClient } from "../../features/client/clientInterface";
import { v4 as uuidv4 } from "uuid";

export const useClientPopulate = (clientInfo : ClientInfoData | undefined) => {
    
    const dispatch = useDispatch()

    const populateClientInfo = () => {
        if(!clientInfo) return;

        const deceasedName = clientInfo.deceasedName
        const registeredBy = clientInfo.registeredBy

        const scheduleFrom = formatDateFromApi(clientInfo.schedule_from)
        const scheduleTo = formatDateFromApi(clientInfo.schedule_to)

        const startTime = formatTimeFromApi(clientInfo.schedule_from)
        const endTime = formatTimeFromApi(clientInfo.schedule_to)
        
        dispatch(updateClientFormField({ field: 'deceasedName', value: deceasedName }))
        dispatch(updateClientFormField({ field: 'registeredBy', value: registeredBy }))
        dispatch(updateClientFormField({ field: 'scheduleFrom', value: scheduleFrom }))
        dispatch(updateClientFormField({ field: 'scheduleTo', value: scheduleTo }))
        dispatch(updateClientFormField({ field: 'startTime', value: startTime }))
        dispatch(updateClientFormField({ field: 'endTime', value: endTime }))
    }

    const populateHeritageInformation = () => {
        if(!clientInfo) return;

        const email = clientInfo.email;
        const mobileNo = clientInfo.mobileNo

        dispatch(updateClientFormField({ field: 'email', value: email }))
        dispatch(updateClientFormField({ field: 'mobileNo', value: mobileNo }))
    }

    const populateChapel = () => {
        if(!clientInfo) return;

        const chapels = clientInfo.chapels?.map((chap: any) => ({
            chapelID: chap.chapelID,
            chapelName: chap.chapelName,
        })) ?? [];

        dispatch(updateClientFormField({ field: 'chapels', value: chapels }))
    }

    const populateAdditionalInfo = () => {
        if(!clientInfo) return;

        const contactPersons =
                clientInfo.contacts?.map((contact: any): Person => ({
                    contactID: contact.contactID,
                    name: contact.contactPersonName,
                    number: contact.contactPersonNumber,
                })) ?? [
                    {
                        contactID: generateRandomNumber(),
                        name: "",
                        number: "09",
                    },
                ]
        dispatch(updateClientFormField({ field: 'contactPersons', value: contactPersons }))
    }

    const populateExtraPackages = () => {
        if(!clientInfo) return;
        
        const extraPackages: ExtraPackagesData[] = 
            clientInfo.packageSummary.map((pkg: SelectPackageClient) => ({
                        localId: uuidv4(),
                        packageId: pkg.packageID,

                        startDate: formatDateFromApi(pkg.validFrom),
                        startTime: formatTimeFromApi(pkg.validFrom),

                        endDate: formatDateFromApi(pkg.validTo),
                        endTime: formatTimeFromApi(pkg.validTo),

                        packageName: pkg.packageName,
                        isDefaultPackage: pkg.isDefaultPackage,
                        totalValue: pkg.totalValue,
                        quantity: pkg.quantity,
                        remainingQty: pkg.remainingQty,
                        packageType: pkg.packageType,
                        products: pkg.products,
                        clientPackageId: pkg.clientPackageId,

                        downpayment: pkg.downpayment ?? null,
                        receiptDate: formatDateFromApi(pkg.receiptDate ?? ''),
                        receiptId: pkg.receiptId ?? '',
                        netSpent: pkg.netSpent ?? null,
                        remainingBalance: pkg.remainingBalance ?? null
                    })) ?? []
                    
        // dispatch(updateClientFormField({ field: 'extraPackages', value: extraPackages }))
        dispatch(setAllPackageFromApi(extraPackages))
    }

    // const populateData = useMemo(() => {
    //     if (!clientInfo) return null;

    //     return {
    //         deceasedName: clientInfo.deceasedName,
    //         registeredBy: clientInfo.registeredBy,
    //         mobileNo: clientInfo.mobileNo,
    //         email: clientInfo.email,

    //         scheduleFrom: formatDateFromApi(clientInfo.schedule_from),
    //         scheduleTo: formatDateFromApi(clientInfo.schedule_to),

    //         startTime: formatTimeFromApi(clientInfo.schedule_from),
    //         endTime: formatTimeFromApi(clientInfo.schedule_to),

    //         chapelID: clientInfo.chapelID,
    //         chapelName: clientInfo.chapelName,

    //         contactPersons:
    //             clientInfo.contacts?.map((contact: any): Person => ({
    //                 contactID: contact.contactID,
    //                 name: contact.contactPersonName,
    //                 number: contact.contactPersonNumber,
    //             })) ?? [
    //                 {
    //                     contactID: generateRandomNumber(),
    //                     name: "",
    //                     number: "09",
    //                 },
    //             ],

    //         chapels:
    //             clientInfo.chapels?.map((chap: any) => ({
    //                 chapelID: chap.chapelID,
    //                 chapelName: chap.chapelName,
    //             })) ?? [],

    //         extraPackages:
    //             clientInfo.packageSummary
    //                 ?.filter((pkg: any) => pkg.packageType === "extra")
    //                 .map((pkg: any) => ({
    //                     packageId: pkg.packageID,

    //                     startDate: formatDateFromApi(pkg.validFrom),
    //                     startTime: formatTimeFromApi(pkg.validFrom),

    //                     endDate: formatDateFromApi(pkg.validTo),
    //                     endTime: formatTimeFromApi(pkg.validTo),

    //                     packageName: pkg.packageName,
    //                     isDefaultPackage: pkg.isDefaultPackage,
    //                     totalValue: pkg.totalValue,
    //                     quantity: pkg.quantity,
    //                     remainingQty: pkg.remainingQty,
    //                 })) ?? [],
    //     };
    // }, [clientInfo]);

    return {
        populateClientInfo,
        populateHeritageInformation,
        populateChapel,
        populateAdditionalInfo,
        populateExtraPackages,
    };
};